import React, { useState } from "react";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";

function Communications(props) {
  const state = props.state;

  return (
    <ButtonContainer label="Manage Communications">
      <CheckableButton
        id="subscribe_newsletter"
        toggle
        onChange={props.handleCheckboxChange}
        checked={state.subscribe_newsletter}
        disabled
      >Subscribe to newsletter</CheckableButton>
      <CheckableButton
        id="subscribe_updates"
        toggle
        onChange={props.handleCheckboxChange}
        checked={state.subscribe_updates}
        disabled
      >Subscribe to job updates</CheckableButton>
    </ButtonContainer>
  )
}

export default Communications;